import { ICart } from "@features/cart/ICart";
import { selectOfferInCartByServiceGroup } from "@utils/offerUtils";
import { EServiceGroup } from "@constants";

export const getCartItemsNumber = (cart: ICart) => {
    const broadbandOffer = selectOfferInCartByServiceGroup(cart, EServiceGroup.SA_BB);

    if (broadbandOffer) {
        return cart.offers.length + broadbandOffer.addOns.length;
    }

    return cart.offers.length;
};
